export enum TechnologyGroupEnum {
  POS = 'POS',
  TEF = 'TEF',
  E_COMMERCE = 'COM',
  LNK = 'LNK',
}
